import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import { Database } from "../db/store";

export const DatabaseContext = createContext<{
  db: Database | undefined;
}>({
  db: undefined,
});

export const DatabaseProvider: React.FC<{
  children?: ReactNode;
  dbName: string;
  upgradeDb: (db: IDBDatabase) => void | Promise<void>;
  version?: number;
}> = ({ children, dbName, upgradeDb, version = 1 }) => {
  const [db, setDB] = useState<Database>();

  useEffect(() => {
    let isRunning = true;
    Database.create(dbName, upgradeDb, version).then((db) => {
      if (isRunning) setDB(db);
    });
    return () => {
      isRunning = false;
    };
  }, [dbName, upgradeDb, version]);

  return (
    <DatabaseContext.Provider value={{ db }}>
      {db ? children : null}
    </DatabaseContext.Provider>
  );
};

export const useDatabase = () => {
  const { db } = useContext(DatabaseContext);
  if (!db)
    throw new Error(
      "Database not initialised. Maybe you forgot to create <DatabaseProvider>?"
    );
  return db;
};
